import React from 'react';
import { motion } from 'framer-motion';
import { Lightbulb, Book, Users, Globe } from 'lucide-react';

const approaches = [
  {
    icon: Lightbulb,
    title: 'Executive Education',
    description: 'Professional courses enhancing climate finance expertise.',
  },
  {
    icon: Book,
    title: 'Academic Integration',
    description: 'Strengthening university curricula with climate finance.',
  },
  {
    icon: Users,
    title: 'Stakeholder Engagement',
    description: 'Building networks for sustainable development.',
  },
  {
    icon: Globe,
    title: 'Research & Advisory',
    description: 'Evidence-based solutions for climate challenges.',
  },
];

export default function Approach() {
  return (
    <section className="relative py-32 bg-gradient-to-br from-green-900 via-emerald-900 to-teal-900">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-1.2.1&auto=format&fit=crop&w=1920&q=80')] opacity-10" />
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-20"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl font-bold text-white mb-6">Our Approach</h2>
          <p className="text-green-100 text-lg max-w-2xl mx-auto">
            Delivering comprehensive solutions through innovative methods and partnerships
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {approaches.map((item, index) => (
            <motion.div
              key={item.title}
              className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-white/20"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -5 }}
            >
              <item.icon className="w-10 h-10 text-green-300 mb-6" />
              <h3 className="text-xl font-semibold text-white mb-4">{item.title}</h3>
              <p className="text-green-100">{item.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}